export default __webpack_public_path__ + "static/media/prize-4.9dd3a96f.webp";